import { Component, OnInit } from '@angular/core';
import { BrowserService } from './core';
import { AuthService } from './core/services/auth.service';
import {
  forceLogoutStaleSession,
  isStoredSessionMissingToken,
} from './helpers/login-session.helper';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: { ngSkipHydration: 'true' },
})
export class AppComponent implements OnInit {
  isBrowser: any;

  constructor(
    private _browserService: BrowserService,
    private _authService: AuthService,
  ) {}

  ngOnInit() {
    this.isBrowser = this._browserService.checkBrowser();
    if (this.isBrowser && isStoredSessionMissingToken()) {
      forceLogoutStaleSession(this._authService);
    }
  }
}
